import { useState } from "react"

import { DownloadOutlined } from "@ant-design/icons"
import { Button, Flex, Space, Typography } from "antd"
import cls from "classname"

import ButtonComponent from "../../Button"

import "./styles.less"

const { Text } = Typography

const RecoveryCodesBlock = ({
  t = (value) => value,
  onSuccess,
  onCancel,
  isSetupMode = false,
  recoveryCodes = [],
  buttonText = "I've saved my codes",
  requireDownloadBeforeContinue = true,
  isSubmitting = false
}) => {
  const [hasDownloadedCodes, setHasDownloadedCodes] = useState(false)

  const downloadRecoveryCodes = (codes = []) => {
    const content = ["code", ...codes].join("\n")

    const blob = new Blob([content], {
      type: "text/csv;charset=utf-8"
    })

    const url = URL.createObjectURL(blob)

    const link = document.createElement("a")
    link.href = url
    link.download = "chargeback-recovery-codes.csv"
    link.click()
    setHasDownloadedCodes(true)

    URL.revokeObjectURL(url)
  }
  return (
    <Space direction="vertical" size={20} className="security-recovery-block">
      <Space direction="vertical" size={4}>
        <Text strong>{t("Recovery codes")}</Text>

        <Text type="secondary">
          {t("Recovery codes let you sign in if you lose access to your authenticator app.")}
        </Text>

        <Text>
          <Text type="warning">{t("Keep your recovery codes in a safe spot.")}</Text>{" "}
          {t(
            "If you lose your device and don't have the recovery codes, you will lose access to your account."
          )}
        </Text>
      </Space>

      <Button
        icon={<DownloadOutlined />}
        onClick={() => downloadRecoveryCodes(recoveryCodes)}
        block
      >
        {t("Download codes")}
      </Button>

      <div className="security-recovery-codes">
        {recoveryCodes.map((code, index) => (
          <div key={index} className="security-recovery-code-item">
            {code}
          </div>
        ))}
      </div>

      <Flex gap={12}>
        <ButtonComponent
          type="primary"
          onClick={onSuccess}
          loading={isSubmitting}
          block={isSetupMode}
          disabled={isSubmitting || (requireDownloadBeforeContinue && !hasDownloadedCodes)}
          className={cls("security-recovery-save-btn", {
            "full-width": isSetupMode
          })}
        >
          {t(buttonText)}
        </ButtonComponent>

        {!isSetupMode && (
          <ButtonComponent onClick={onCancel} disabled={isSubmitting}>
            {t("Cancel")}
          </ButtonComponent>
        )}
      </Flex>
    </Space>
  )
}

export default RecoveryCodesBlock
